import React from 'react'
import { charcuterieData } from '../data'
import { CharcuterieItem } from '../components'

function Charcuterie() {
	return (
		<div className="CharcuterieContainer">
			{charcuterieData.map(item => (
				<>
					<CharcuterieItem item={item} key={item.id} />
				</>
			))}
		</div>
	)
}

export default Charcuterie
